import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import { sanitizeRows } from 'src/app/shared/utils/sanitize-export';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Injectable()
export class ExportService {

  constructor() { }

  public exportAsExcelFile(json: any[], excelFileName: string): void {
    
    // SECURITY (audit obs #9 - Formula Injection, CWE-1236): neutralise
    // formula-trigger characters before the rows reach the sheet. sanitizeRows
    // returns copies, so the caller's array - often still bound to the grid on
    // screen - is left untouched.
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(sanitizeRows(json));
  // console.log('worksheet',worksheet);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    //const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'buffer' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
  // console.log(data)
   FileSaver.saveAs(data, "ds_"+fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
   
  }

}